import useShowSuccess from 'hooks/useShowSuccess'
import { useCompleteTransactionMutation, InputUpdateTransactionItem } from '../../../graphql'

export default function useCompleteTransactionHandler( options?: any ) {
	const [ completeTransaction ] = useCompleteTransactionMutation( options )
	const showSuccess = useShowSuccess()

	return async( transactionId: number, transactionItems: InputUpdateTransactionItem[] ) => {
		await completeTransaction( { variables: { transactionId, transactionItems } } )
		showSuccess( `completeTransaction${Date.now()}`, 'Success!' )
	}
}
